
import { Component, Vue, Prop } from "vue-property-decorator";
import { namespace } from "vuex-class";
import CustomDefinedField from "./CustomDefinedField.vue";
import { CustomFieldValues, CustomFieldDto, CustomFieldTableTypes } from "@/store/custom-fields/types";
import { sortOrderByNullLast } from "@/utils/CustomFieldLogic";

const CustomFields = namespace("customFields");

@Component({
	components: {
		"custom-field": CustomDefinedField
	}
})
export default class CustomDefinedFieldInput extends Vue {
	@Prop({ type: Array, required: false}) public customFieldValues: CustomFieldValues[];
	@Prop({ type: Number, required: true}) public customFieldTableTypeId: number;
	@Prop({ type: Boolean, required: false}) public belongsToGroupSync: boolean;

	@CustomFields.State private deviceCustomFields: CustomFieldDto[];
	@CustomFields.State private serverCustomFields: CustomFieldDto[];
	@CustomFields.Action retrieveCustomFields: ({ tableType, live, skipCancel }) => Promise<void>;

	private customFieldList: CustomFieldDto[] = [];
	private customFieldsToShow: CustomFieldValues[] = [];
	private sortByOrder: string = "order";
	private newCustomFieldValues: CustomFieldValues[] = [];

	private async mounted(): Promise<void> {
		await this.retrieveCustomFields({ tableType: this.customFieldTableTypeId, live: true , skipCancel: true });
		this.customFieldList = this.retrieveCustomFieldsForTableType(this.customFieldTableTypeId);
		sortOrderByNullLast(this.customFieldList);
		this.assignCustomFieldsToShow();
		this.setupCustomFieldValuesForEdit();
	}

	private customFieldSetting(customFieldToShow: CustomFieldValues): CustomFieldDto {
		return this.customFieldList.find(cf => cf.id == customFieldToShow.id)
	}

	private retrieveCustomFieldsForTableType(tableTypeId: number): CustomFieldDto[] {
		if (tableTypeId == CustomFieldTableTypes.Server) {
			return this.serverCustomFields;
		}

		if (tableTypeId == CustomFieldTableTypes.Device) {
			return this.deviceCustomFields;
		}
	}

	private assignCustomFieldsToShow(): void {
		if (!this.customFieldValues?.length) {
			for (let i = 0; i<this.customFieldList.length; i++) {
				this.customFieldsToShow.push({
					id: this.customFieldList[i].id,
					value: "",
				});
			}
		}

		if (this.customFieldValues?.length) {
				for(let i=0; i<this.customFieldList.length; i++) {
				let foundValue = this.customFieldValues.find(cf => cf.id == this.customFieldList[i].id);

				if (foundValue) {
					this.customFieldsToShow.push({
						id: this.customFieldList[i].id,
						value: foundValue.value,
					});
				}
				else {
					this.customFieldsToShow.push({
						id: this.customFieldList[i].id,
						value: "",
					});
				}
			}
		}
	}

	private setupCustomFieldValuesForEdit(): void {
		this.customFieldsToShow.forEach(cf => {
			let value = "";
			let foundField;

			if (this.customFieldValues && this.customFieldValues.length > 0) {
				foundField = this.customFieldValues.find(cfv => cfv.id == cf.id)

				if (foundField) {
					value = foundField.value
				}
			}

			this.newCustomFieldValues.push({
				id: cf.id,
				value: value
			});
		});
	}

	private updateCustomFieldValue(updatedValue: CustomFieldValues): void {
		let targetCustomField = this.newCustomFieldValues.find(cf => cf.id === updatedValue.id)

		if (targetCustomField) {
			targetCustomField.value = updatedValue.value;
		}

		this.$emit('CFValueListChanged', this.newCustomFieldValues);
	}
}
